/* Craftly: Thumbnail preview for image uploads + auto-hide upload button when file selected */
(function(){
  if (window.__craftlyUploadPreview) return;
  window.__craftlyUploadPreview = true;

  function looksLikeImageInput(input){
    if (input.type !== 'file') return false;
    var accept = (input.accept || '').toLowerCase();
    return !accept || accept.indexOf('image') >= 0 || accept.indexOf('*') >= 0;
  }

  function readPreview(file){
    return new Promise(function(resolve){
      try { resolve(URL.createObjectURL(file)); } catch(e){ resolve(''); }
    });
  }

  function humanSize(bytes){
    if (bytes < 1024) return bytes + 'B';
    if (bytes < 1024*1024) return Math.round(bytes/1024) + 'KB';
    return (bytes/1024/1024).toFixed(1) + 'MB';
  }

  // Walk up to find the LPO field wrapper (or any reasonable container)
  function findWrapper(input){
    var p = input;
    // Look up to 6 levels
    for (var i=0; i<6 && p && p.parentElement; i++){
      p = p.parentElement;
      var cls = (p.className || '') + '';
      if (/lpo|file-?upload|upload-?field|field-?wrapper/i.test(cls)) return p;
    }
    // Fallback: closest parent that ALSO contains the "click here" text
    p = input.parentElement;
    for (var j=0; j<6 && p && p !== document.body; j++){
      var t = (p.textContent || '');
      if (t.indexOf('לחצו') >= 0 || t.indexOf('Click') >= 0) return p;
      p = p.parentElement;
    }
    return input.parentElement;
  }

  // Find the LPO "click here to choose" button(s) within the wrapper
  function findUploadButtons(input, wrapper){
    var btns = [];
    var els = wrapper.querySelectorAll('button, label, [role="button"], a, div, span');
    els.forEach(function(el){
      // Skip our own preview elements
      if (el.closest && el.closest('.cup-preview')) return;
      if (el === input) return;
      // Skip if it contains the input or our preview (parent elements)
      if (el.contains && (el.contains(input) || el.querySelector('.cup-preview'))) return;
      var text = (el.textContent || '').trim();
      // Only match elements whose own text (mostly) is the upload-button text
      if (text.length === 0 || text.length > 80) return;
      if (text.indexOf('לחצו') >= 0 || text.indexOf('בחירת תמונה') >= 0 ||
          /click.*(choose|upload|select)/i.test(text) || text === 'Choose File') {
        btns.push(el);
      }
    });
    return btns;
  }

  function attach(input){
    if (input.__cup) return;
    if (!looksLikeImageInput(input)) return;
    input.__cup = true;

    // Place preview right after the visible anchor
    var anchor = input;
    if (input.offsetParent === null) {
      var p = input.parentElement;
      while (p && p.offsetParent === null && p !== document.body) p = p.parentElement;
      if (p) anchor = p;
    }

    var wrapper = findWrapper(input);

    var preview = document.createElement('div');
    preview.className = 'cup-preview';
    preview.setAttribute('aria-live','polite');
    anchor.parentNode.insertBefore(preview, anchor.nextSibling);

    function setButtonsVisible(visible){
      var btns = findUploadButtons(input, wrapper);
      btns.forEach(function(btn){
        if (visible) {
          if (btn.dataset.cupHidden) {
            btn.style.display = btn.dataset.cupOrigDisplay || '';
            delete btn.dataset.cupHidden;
            delete btn.dataset.cupOrigDisplay;
          }
        } else {
          if (!btn.dataset.cupHidden) {
            btn.dataset.cupOrigDisplay = btn.style.display || '';
            btn.style.display = 'none';
            btn.dataset.cupHidden = '1';
          }
        }
      });
    }

    function clearFile(){
      // Clear the input and dispatch change so LPO updates internally
      try { input.value = ''; } catch(e){}
      // Some inputs need a DataTransfer reset for reliability
      try {
        if (typeof DataTransfer !== 'undefined'){
          var dt = new DataTransfer();
          input.files = dt.files;
        }
      } catch(e){}
      input.dispatchEvent(new Event('change', { bubbles:true }));
      input.dispatchEvent(new Event('input', { bubbles:true }));
      // Re-render (will show empty preview + show buttons back)
      render();
    }

    function render(){
      preview.innerHTML = '';
      var files = Array.from(input.files || []);

      if (!files.length){
        setButtonsVisible(true);  // show "click here" again
        return;
      }

      setButtonsVisible(false);   // hide "click here" while file present

      var header = document.createElement('div');
      header.className = 'cup-preview-header';
      header.innerHTML = '<span class="cup-preview-eyebrow">📸 התמונה שלכם</span>';
      preview.appendChild(header);

      var grid = document.createElement('div');
      grid.className = 'cup-preview-grid';
      preview.appendChild(grid);

      files.forEach(function(file){
        if (!file.type || file.type.indexOf('image/') !== 0) return;

        var card = document.createElement('div');
        card.className = 'cup-preview-card';

        var imgWrap = document.createElement('div');
        imgWrap.className = 'cup-preview-imgwrap';
        var img = document.createElement('img');
        img.alt = file.name || '';
        img.loading = 'lazy';
        imgWrap.appendChild(img);

        // DELETE BUTTON (×) — clears file so user can upload another
        var del = document.createElement('button');
        del.type = 'button';
        del.className = 'cup-preview-del';
        del.setAttribute('aria-label', 'מחק תמונה');
        del.setAttribute('title', 'מחק והעלה תמונה אחרת');
        del.textContent = '✕';
        del.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          clearFile();
        });
        imgWrap.appendChild(del);

        var meta = document.createElement('div');
        meta.className = 'cup-preview-meta';
        var name = (file.name || '').replace(/\.[^.]+$/, '');
        if (name.length > 22) name = name.slice(0, 20) + '...';
        meta.innerHTML = '<span class="cup-preview-name">' + name + '</span>' +
                        '<span class="cup-preview-size">' + humanSize(file.size) + '</span>';

        card.appendChild(imgWrap);
        card.appendChild(meta);
        grid.appendChild(card);

        readPreview(file).then(function(url){ img.src = url; });
      });
    }

    input.addEventListener('change', render);
    input.addEventListener('input', render);
    if (input.files && input.files.length) render();
  }

  function scan(root){
    (root || document).querySelectorAll('input[type="file"]').forEach(attach);
  }

  var obs = new MutationObserver(function(muts){
    muts.forEach(function(m){
      Array.from(m.addedNodes).forEach(function(n){
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('input[type="file"]')) attach(n);
        else if (n.querySelectorAll) scan(n);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      scan();
      obs.observe(document.body, { childList:true, subtree:true });
    });
  } else {
    scan();
    obs.observe(document.body, { childList:true, subtree:true });
  }

  if (!document.getElementById('cup-style')){
    var st = document.createElement('style');
    st.id = 'cup-style';
    st.textContent =
      '.cup-preview{margin:12px 0 6px;direction:rtl;font-family:inherit}' +
      '.cup-preview-header{margin:0 0 8px}' +
      '.cup-preview-eyebrow{display:inline-flex;align-items:center;gap:5px;font-size:11px;font-weight:800;color:#D6336C;background:rgba(214,51,108,.10);padding:5px 10px;border-radius:999px;border:1px solid rgba(214,51,108,.20);letter-spacing:.3px}' +
      '.cup-preview-grid{display:flex;flex-wrap:wrap;gap:10px}' +
      '.cup-preview-card{width:100px;background:#fff;border:2px solid rgba(214,51,108,.30);border-radius:12px;overflow:hidden;box-shadow:0 3px 10px rgba(214,51,108,.12);transition:transform .15s ease}' +
      '.cup-preview-card:hover{transform:translateY(-2px);box-shadow:0 6px 16px rgba(214,51,108,.22)}' +
      '.cup-preview-imgwrap{width:100%;aspect-ratio:1/1;background:linear-gradient(135deg,#FCE4EC,#F8BBD0);position:relative;overflow:hidden}' +
      '.cup-preview-imgwrap img{width:100%;height:100%;object-fit:cover;display:block}' +
      '.cup-preview-del{position:absolute;top:6px;left:6px;width:24px;height:24px;border-radius:50%;border:none;background:rgba(0,0,0,.65);color:#fff;font-size:13px;font-weight:900;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;line-height:1;box-shadow:0 2px 6px rgba(0,0,0,.25);transition:background .15s ease,transform .15s ease;z-index:2}' +
      '.cup-preview-del:hover{background:#D6336C;transform:scale(1.10)}' +
      '.cup-preview-meta{padding:6px 7px 8px;text-align:center;display:flex;flex-direction:column;gap:1px;background:#fff}' +
      '.cup-preview-name{display:block;font-size:11px;font-weight:700;color:#0B0B0B;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.cup-preview-size{display:block;font-size:9px;font-weight:600;color:#7A746D}';
    document.head.appendChild(st);
  }
})();
